import { render, staticRenderFns } from "./hallStatus.vue?vue&type=template&id=2bf004b8&scoped=true&"
import script from "./hallStatus.vue?vue&type=script&lang=js&"
export * from "./hallStatus.vue?vue&type=script&lang=js&"
import style0 from "./hallStatus.vue?vue&type=style&index=0&id=2bf004b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf004b8",
  null
  
)

export default component.exports